import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.848 8.142V6.576a1.567 1.567 0 0 0-3.133 0v-.784a1.567 1.567 0 0 0-3.125 0v.784a1.567 1.567 0 0 0-3.125 0v5.466a3.124 3.124 0 0 0-3.125 3.134 7.358 7.358 0 0 0 1.367 4.266l1.141 1.592a4.692 4.692 0 0 0 3.817 1.967h3.992a5.332 5.332 0 0 0 5.341-5.334V8.142a1.568 1.568 0 0 0-2.188-1.55 1.565 1.565 0 0 0-.937 1.55h-.025Z",
			fill: "#fff",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.465 12.042v2.35m3.125-3.908V6.576m3.125 3.908V6.576m3.133 3.908V8.142",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M17.848%208.142V6.576a1.567%201.567%200%200%200-3.133%200v-.784a1.567%201.567%200%200%200-3.125%200v.784a1.567%201.567%200%200%200-3.125%200v5.466a3.124%203.124%200%200%200-3.125%203.134%207.358%207.358%200%200%200%201.367%204.266l1.141%201.592a4.692%204.692%200%200%200%203.817%201.967h3.992a5.332%205.332%200%200%200%205.341-5.334V8.142a1.568%201.568%200%200%200-2.188-1.55%201.565%201.565%200%200%200-.937%201.55h-.025Z%22%20fill%3D%22%23fff%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M8.465%2012.042v2.35m3.125-3.908V6.576m3.125%203.908V6.576m3.133%203.908V8.142%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
